
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { ServiceFormValues } from "../types";
import { CurrencyInput } from "@/components/ui/currency-input";
import { useEffect } from "react";

interface ServiceDetailsFieldsProps {
  form: UseFormReturn<ServiceFormValues>;
}

export const ServiceDetailsFields = ({ form }: ServiceDetailsFieldsProps) => {
  // Convert duration from minutes to hours for display when the component mounts
  useEffect(() => {
    const durationMinutes = form.getValues("duration");
    if (durationMinutes && typeof durationMinutes === 'number') {
      // We don't need to update the form here, just display the converted value in the UI
      // The conversion is handled in the input's value and onChange handler
    }
  }, [form]);

  return (
    <>
      <FormField
        control={form.control}
        name="duration"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Durée (heures)</FormLabel>
            <FormControl>
              <Input 
                type="number" 
                min={0.5}
                step={0.5}
                required 
                {...field}
                onChange={e => {
                  // Convert hours to minutes for storage
                  const hoursValue = parseFloat(e.target.value);
                  const minutesValue = Math.round(hoursValue * 60);
                  field.onChange(minutesValue);
                }}
                value={field.value ? (field.value / 60).toString() : ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="price"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Prix</FormLabel>
            <FormControl>
              <CurrencyInput
                value={field.value || 0}
                onChange={field.onChange}
                currency={form.watch("currency") || "EUR"}
                onCurrencyChange={(value) => form.setValue("currency", value)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
